/*
 * @Description: 月度个人盈利看板
 * @Author: 杨志航
 * @Date: 2026-08-31 16:04:17
 */
import React, { useState, useEffect, useRef } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Select,
  Input,
  InputNumber,
  Button,
  Alert,
  DatePicker,
  message,
  Popconfirm,
  Drawer,
  Switch,
} from 'antd'
import { allTrim, filterParams } from '@/utils'
import Import from '@/components/Import'
import EditProfit from '../module/EditProfit'
import ChangeLog from '../module/ChangeLog'
import BindStaff from '../module/BindStaff'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const { MonthPicker } = DatePicker
const dateFormat = 'YYYY-MM'

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage
}

const Main = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const { history } = props
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(true)
  const [importVisible, setImportVisible] = useState(false)
  const [importType, setImportType] = useState('cost')
  const [companyList, setCompanyList] = useState([])
  const [groupList, setGroupList] = useState([])
  const [editVisible, setEditVisible] = useState(false)
  const [logVisible, setLogVisible] = useState(false)
  const [editData, setEditData] = useState({})
  const [miniProgramSwitch, setMiniProgramSwitch] = useState(false)
  const [departmentTypeList, setDepartmentTypeList] = useState([])
  const [bindVisible, setBindVisible] = useState(false)
  const ImportRef = useRef()

  useEffect(() => {
    resetParams()
    getList()
    getSearchData()
    api.getProfitReportMiniProgram().then(data => {
      setMiniProgramSwitch(data === '1')
    })
  }, [])
  //获取检索所需数据
  const getSearchData =  () => {
    api.getProfitReportSearchData().then(res => {
      const { departmentType } = res
      setDepartmentTypeList(departmentType)
    })
    api.getGroupDepartList().then(data => {
      setGroupList(data)
    })
    api.getSelectCompanyList({ limit: global.paramsLimit }).then(data => {
      setCompanyList(data.list)
    })
  }

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    api.getProfitReportList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    currentPage = 1
    resetParams()
    getList()
  }
  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (vals.yearMonth) {
          vals.yearMonth = vals.yearMonth.format(dateFormat)
        }
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  const onDelete = id => {
    api.delProfitReport({
      id: id
    }).then(() => {
      message.success('删除成功')
      getList()
    })
  }

  const onShowImportDialog = type => {
    setImportType(type)
    ImportRef.current.onRemoved()
    setImportVisible(true)
  }

  const onConfirmImport = (fileList) => {
    if (fileList[0].status !== 'removed') {
      const { name, full, url } = fileList[0]
      api.importProfitReport({
        type: importType === 'cost' ? 1 : 2,
        name,
        full,
        relative: url,
      }).then(res => {
        message.success('导入成功')
        ImportRef.current.onLoading()
        setImportVisible(false)
        onReset()
      }).catch(res => {
        ImportRef.current.onLoading()
      })
    } else {
      message.error('请导入模板')
    }
  }

  const onEdit = record => {
    setEditData(record)
    setEditVisible(true)
  }

  const onChangeLog = record => {
    setEditData(record)
    setLogVisible(true)
  }

  const onMiniProgramSwitchChange = checked => {
    setMiniProgramSwitch(checked)
    api.setProfitReportMiniProgram({
      isOpen: checked ? 1 : 2
    }).then(() => {
      message.success('设置成功')
    }).catch(() => {
      setMiniProgramSwitch(!checked)
    })
  }

  return (
   <>
    <div className="search-doc-wrap">
        <Form onSubmit={formSubmit}  {...formItemLayout}>
          <div className="form-box">
            <FormItem label="员工姓名">
              {getFieldDecorator('staffName')(<Input placeholder="请输入员工姓名" />)}
            </FormItem>
            <FormItem label="员工编号">
              {getFieldDecorator('staffNo')(<InputNumber placeholder="请输入员工编号" style={{ width: '100%'}} />)}
            </FormItem>
            <FormItem label="主体">
              {getFieldDecorator('companyId')(<Select 
                placeholder="请选择"
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {
                  companyList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="事业群">
              {getFieldDecorator('groupId')(<Select 
                placeholder="请选择"
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {
                  groupList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="部门">
              {getFieldDecorator('departmentName')(<Input placeholder="请输入部门" />)}
            </FormItem>
            <FormItem label="部门类型">
              {getFieldDecorator('departmentType')(<Select 
                placeholder="请选择"
                allowClear
              >
                {
                  departmentTypeList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="月度">
              {getFieldDecorator('yearMonth')(<MonthPicker placeholder="请选择月份" style={{ width: '100%' }} />)}
            </FormItem>
          </div>
          <FormItem className="btns" label=" " colon={false}>
            <Button type="primary" htmlType="submit">查询</Button>
            <Button onClick={onReset}>重置</Button>
          </FormItem>
        </Form>
      </div>
      <div className="line"></div>
      <div>
        <div className="add-wrap">
          {/* <Button type="primary" onClick={() => history.push('/ach/probationachaudit/dargsample')}>名称排序</Button> */}
          <Button type="primary" onClick={() => setBindVisible(true)} style={{ marginLeft: 15 }}>权限设置</Button>
          <Button type="primary" onClick={() => onShowImportDialog('cost')} style={{ marginLeft: 15 }}>成本导入</Button>
          <Button type="primary" onClick={() => onShowImportDialog('revenue')} style={{ marginLeft: 15 }}>业绩导入</Button>
        </div>
        <Alert className="corp-count" message={<>
          <span>总共{count}条数据</span>
          <span style={{ marginLeft: 20 }}>
            小程序入口开关：
            <Switch 
              checked={miniProgramSwitch} 
              onChange={onMiniProgramSwitchChange}
            />
          </span>
        </>} type="info" showIcon />
        <Table
          size="small"
          dataSource={list}
          rowKey="id"  
          loading={loading}
          pagination={{
            pageSize,
            total: count,
            current: currentPage,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
          }}
          onChange={onChangeTable}
          rowClassName={record => {
            const { personalNetProfit, achResult } = record
            let rowClassName = ''
            if (personalNetProfit !== '' || achResult !== '') {
              rowClassName = (record.personalNetProfit > 0 || parseFloat(record.achResult) === 100) ? 'table-row-blue' : 'table-row-red'
            }
            return rowClassName
          }}
        >
          <Column title="月度" dataIndex="yearMonth" />
          <Column title="员工编号" dataIndex="staffNo" />
          <Column title="员工姓名" dataIndex="staffName" />
          <Column title="事业群名称" dataIndex="groupName" />
          <Column title="部门名称" dataIndex="departmentName" />
          <Column title="部门类型" dataIndex="departmentType" />
          <Column title="所属主体" dataIndex="companyName" />     
          <Column title="人员成本(元)" dataIndex="personalCost" />
          <Column title="订单业绩(元)" dataIndex="personalRevenue" />
          <Column title="消耗业绩(元)" dataIndex="consumeRevenue" />
          <Column 
            title="个人净利一(元)" 
            dataIndex="personalNetProfit" 
            render={(text, record) =>(
              <span style={{ color: record.personalNetProfit > 0 ? '#1890ff' : 'red' }}>{text}</span>
            )}
          />
          <Column 
            title="贡献率" 
            dataIndex="contributionRate" 
            render={(text, record) =>(
              <span style={{ color: record.personalNetProfit > 0 ? '#1890ff' : 'red' }}>{text}</span>
            )}
          />
          <Column 
            title="绩效" 
            dataIndex="achResult" 
            render={(text, record) =>(
              <span style={{ color: parseFloat(text) >= 100 ? '#1890ff' : 'red' }}>{text}</span>
            )}
          />
          <Column title="操作"
            key="set" 
            fixed="right"
            align="center"
            width={120}
            render={(text, record) => (
              <>
                <a onClick={() => onEdit(record)}>修改</a>
                <Popconfirm 
                  title={`员工“${record.staffName}”在“${record.yearMonth}”的人员信息及修改记录将被删除，请确认是否删除？`} 
                  cancelText="取消" okText="确认" 
                  onConfirm={() => onDelete(record.id)}
                >
                  <a style={{ marginLeft: 8, color: 'red' }}>删除</a>
                </Popconfirm>
                <a onClick={() => onChangeLog(record)} style={{ marginLeft: 8 }}>记录</a>
              </>
            )}
          />
        </Table>
      </div>
      <Import
        title={importType === 'cost' ? '人员自负盈亏信息-成本导入' : '人员自负盈亏信息-业绩导入(包括销售、运营、电商、门店、直播等部门）'}
        onSearch={onConfirmImport}
        visibleFile={importVisible}
        onCloseImport={() => setImportVisible(false)}
        ImportTemplate={`/templates/${importType === 'cost' ? '人员自负盈亏信息-成本导入' : '人员自负盈亏信息-业绩导入(包括销售、运营、电商、门店、直播等部门）'}.xlsx`}
        ImportRef={ImportRef}
      />
      <Drawer
        title="人员盈利信息修改"
        width={600}
        onClose={() => setEditVisible(false)}
        visible={editVisible}
        destroyOnClose={true}
      >
        <EditProfit editData={editData} setVisible={setEditVisible} getList={getList} />
      </Drawer>
      <Drawer
        title="人员盈利信息修改记录"
        width={600}
        onClose={() => setLogVisible(false)}
        visible={logVisible}
        destroyOnClose={true}
      >
        <ChangeLog editData={editData} />
      </Drawer>
      <Drawer
        title="权限设置"
        width={900}
        onClose={() => setBindVisible(false)}
        visible={bindVisible}
        destroyOnClose={true}
      >
        <BindStaff />
      </Drawer>
   </> 
  )
}

export default Form.create()(Main)